export const model = {
    id: null,
    patient_id: "",
    patient: {},
    service_id: "",
    doctor_id: "",
    created_at: '',
    updated_at: '',
};
